import * as React from 'react';
import { RouteObject } from 'react-router-dom';

// Components
import { ClientInfo } from '../../../../components/ClientInfo';
import { SurveyResponsesTable } from '../../../../components/SurveyResponsesTable';

const AdminClients = React.lazy(
    () => import(/* webpackChunkName: "admin-clients" */ '../../../../containers/Admin/Clients')
);
const ClientsTable = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-clients-table" */ '../../../../containers/Admin/Clients/children/ClientsTable'
        )
);
const Client = React.lazy(
    () => import(/* webpackChunkName: "admin-client" */ '../../../../containers/Admin/Clients/children/Client')
);
const ClientImport = React.lazy(
    () => import(/* webpackChunkName: "admin-client-import" */ '../../../../containers/Admin/Clients/children/Import')
);
const ClientContacts = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-clients-contacts" */ '../../../../containers/Admin/Clients/children/Contacts'
        )
);
const ClientContact = React.lazy(
    () =>
        import(/* webpackChunkName: "admin-clients-contact" */ '../../../../containers/Admin/Clients/children/Contact')
);
const ClientLoans = React.lazy(
    () => import(/* webpackChunkName: "admin-clients-loans" */ '../../../../containers/Admin/Clients/children/Loans')
);
const ClientLoan = React.lazy(
    () => import(/* webpackChunkName: "admin-clients-loan" */ '../../../../containers/Admin/Clients/children/Loan')
);
const ClientSurveys = React.lazy(
    () =>
        import(/* webpackChunkName: "admin-clients-surveys" */ '../../../../containers/Admin/Clients/children/Surveys')
);
const ClientSurveyEvents = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-clients-survey-events" */ '../../../../containers/Admin/Clients/children/Surveys/children/Events'
        )
);
const ClientSurveyResponse = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-clients-survey-response" */ '../../../../containers/Admin/Clients/children/Surveys/children/Response'
        )
);

export const AdminClientsRoutes: RouteObject = {
    path: 'clients',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminClients />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientsTable createClient />
                </React.Suspense>
            )
        },
        {
            path: 'import',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientImport />
                </React.Suspense>
            )
        },
        {
            path: 'clientId/:clientId',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <Client />
                </React.Suspense>
            ),
            children: [
                {
                    index: true,
                    element: <ClientInfo />
                },
                {
                    path: 'contacts',
                    element: (
                        <React.Suspense fallback={<>...</>}>
                            <ClientContacts />
                        </React.Suspense>
                    )
                },
                {
                    path: 'contacts/:contactId',
                    element: (
                        <React.Suspense fallback={<>...</>}>
                            <ClientContact />
                        </React.Suspense>
                    )
                },
                {
                    path: 'loans',
                    element: (
                        <React.Suspense fallback={<>...</>}>
                            <ClientLoans />
                        </React.Suspense>
                    )
                },
                {
                    path: 'loans/:loanId',
                    element: (
                        <React.Suspense fallback={<>...</>}>
                            <ClientLoan />
                        </React.Suspense>
                    )
                },
                {
                    path: 'surveys',
                    element: (
                        <React.Suspense fallback={<>...</>}>
                            <ClientSurveys />
                        </React.Suspense>
                    ),
                    children: [
                        {
                            index: true,
                            element: <SurveyResponsesTable />
                        },
                        {
                            path: 'events',
                            element: (
                                <React.Suspense fallback={<>...</>}>
                                    <ClientSurveyEvents />
                                </React.Suspense>
                            )
                        },
                        {
                            path: 'survey/:surveyId',
                            element: (
                                <React.Suspense fallback={<>...</>}>
                                    <ClientSurveyResponse />
                                </React.Suspense>
                            )
                        }
                    ]
                }
            ]
        }
    ]
};
